// extracted by mini-css-extract-plugin
var _1 = "eI3OWRCLeqkdMQ6LOb4h";
var _2 = "ogevO0an6VxMFH4x4t14";
export { _1 as "answer", _2 as "container" }
